import { LogService } from '../../services/log-service';

export const getCompletedManifestMessage = (fallbackResponse) => {
  const { messages } = fallbackResponse;
  try {
    const parsedMessages = [];
    messages.forEach((msg) => parsedMessages.push(JSON.parse(msg)));
    // we will only see the final bit on the new message signiture, so return if found
    const foundFinal = parsedMessages.find((msg) => msg.data?.final);
    if (foundFinal && foundFinal?.data?.message) {
      return foundFinal.data.message;
    }
    return parsedMessages[0]?.data;
  } catch (err) {
    LogService.logError(new Error('Error parsing EOD Manifest fallback message', { cause: err }));
  }
};
